import { useMemo, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { buildClients } from "@/lib/clientImport";

const detail = (e, fallback) => (typeof e?.response?.data?.detail === "string" ? e.response.data.detail : fallback);

// Shared state for "upload a spreadsheet -> match columns -> import" (Clients tab and first-time setup).
export const useClientImport = () => {
  const [sheet, setSheet] = useState(null);
  const [map, setMap] = useState([]);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const clients = useMemo(() => (sheet ? buildClients(sheet.rows, map) : []), [sheet, map]);

  const pick = async (file) => {
    setBusy(true);
    setResult(null);
    try {
      const s = await api.previewClientImport(file);
      setSheet(s);
      setMap(s.columns.map((c) => c.guess || ""));
    } catch (e) { toast.error(detail(e, "We couldn't read that file")); }
    finally { setBusy(false); }
  };
  const setField = (i, v) => setMap((m) => m.map((x, j) => (j === i ? v : x)));
  const run = async (depotId) => {
    setBusy(true);
    try {
      const r = await api.importClientRows({ depot_id: depotId || undefined, clients });
      setResult(r);
      setSheet(null);
      return r;
    } catch (e) { toast.error(detail(e, "Could not import your clients")); return null; }
    finally { setBusy(false); }
  };
  const reset = () => { setSheet(null); setMap([]); setResult(null); };
  return { sheet, map, setField, clients, hasName: map.includes("name"), busy, result, pick, run, reset };
};
